import Record from "./base"

export class Sponsor extends Record {
  constructor(...props) {
    super(...props)
    const [model, data] = props
    let lossy = "fl_lossy,f_auto"
    if (data.image) {
      if (typeof data.image === "string") {
        if (data.image.indexOf("{") > -1) {
          data.image = JSON.parse(data.image)
          this.image_url = encodeURI(
            `//res.cloudinary.com/bidr/image/upload/${lossy},d_WhiteNoTagline_nakbpt.png/${
              data.image.image_version
            }/${data.auctionCode}/web_sponsors/${
              data.image.original_image_name
            }`
          )
        } else {
          let img = data.image.replace(
            /\/events\/images\/event_images\/[\d]{4}\/web_sponsors\//,
            ""
          )
          this.image_url = encodeURI(
            `//res.cloudinary.com/bidr/image/upload/${lossy},d_WhiteNoTagline_nakbpt.png/${
              data.auctionCode
            }/web_sponsors/${img}`
          )
        }
      } else {
        this.image_url = encodeURI(
          `//res.cloudinary.com/bidr/image/upload/${lossy},d_WhiteNoTagline_nakbpt.png/${
            data.image.image_version
          }/${data.auctionCode}/web_sponsors/${data.image.original_image_name}`
        )
      }
    } else {
      this.image_url = encodeURI(
        "//res.cloudinary.com/bidr/image/upload/v1571312506/eg_WhiteNoTagline_nakbpt.png"
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/serializers/sponsor.js